export default __webpack_public_path__ + "assets/models/cf533c711af42754187706cd818cc974.glb";